import { AdaptiveCarousel, AdaptiveCarouselSlide, Button, FlexBox, H2, Link, P } from '@vp/swan';
import { useTrackNavigationClicked } from '../../../../utils/analytics';
import { BlogPost } from '../../../../utils/blog';
import { toSentenceCase } from '../../../../utils/helper';
import BlogPostTile from './BlogPostTile';

interface BlogPostsProps {
    blogPosts: BlogPost[];
    keywordLongName?: string;
}

const BlogPosts = ({ blogPosts, keywordLongName }: BlogPostsProps) => {
    const moreArticlesUrl = 'https://www.vistaprint.com/hub/logo-tips';
    const moreArticlesCtaRef = useTrackNavigationClicked(
        'Logo Ideas',
        'Logo Tips',
        moreArticlesUrl,
        'seeMoreArticles',
    );
    const carouselSlideCount = blogPosts.length;

    return (
        <>
            <H2 fontSkin="title-section" id="logo-tips-heading">
                {keywordLongName ? `${toSentenceCase(keywordLongName)} logo tips` : 'Logo Tips'}
            </H2>

            <P marginBottom="between-subsections">
                {`What makes a great ${keywordLongName ? `${keywordLongName} ` : ''}logo? Discover tips, advice and more
                ${keywordLongName ? `${keywordLongName} ` : ''} logo ideas at our blog, and learn how to create the perfect
                logo that tells your brand's story.`}
            </P>
            <AdaptiveCarousel
                aria-labelledby="logo-tips-heading"
                slidesToShow={{
                    xs: Math.min(2, carouselSlideCount),
                    sm: Math.min(4, carouselSlideCount),
                    md: Math.min(4, carouselSlideCount),
                    lg: Math.min(5, carouselSlideCount),
                    xl: Math.min(6, carouselSlideCount),
                }}
            >
                {blogPosts.map((blogPost: BlogPost, index) => (
                    <AdaptiveCarouselSlide key={index}>
                        <BlogPostTile blogPost={blogPost} />
                    </AdaptiveCarouselSlide>
                ))}
            </AdaptiveCarousel>

            <FlexBox justifyContent="center" alignItems="center">
                <Button
                    render={(props) => (
                        <Link
                            to={moreArticlesUrl}
                            className={props.className}
                            target="_blank"
                            ref={moreArticlesCtaRef}
                        >
                            {props.children}
                        </Link>
                    )}
                >
                    See more articles
                </Button>
            </FlexBox>
        </>
    );
};

export default BlogPosts;
